import { render, staticRenderFns } from "./TrailSystemDetails.vue?vue&type=template&id=4af4674b&scoped=true&"
import script from "./TrailSystemDetails.vue?vue&type=script&lang=js&"
export * from "./TrailSystemDetails.vue?vue&type=script&lang=js&"
import style0 from "./TrailSystemDetails.vue?vue&type=style&index=0&id=4af4674b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af4674b",
  null
  
)

export default component.exports